<template>
  <button id="EXIT" name="EXIT" class="btn txt-btn uppercase" data-vcode="EXIT">
    {{ $t('exitButton') }}
  </button>
</template>
<script>
export default {};
</script>
